import type { StreamingEvent } from '../../types/chat.types';
import type { ContentProcessorState } from '../contentProcessor.types';

export function handleDebugEvent(
  state: ContentProcessorState,
  event: StreamingEvent<'debug'>,
): ContentProcessorState {
  return {
    ...state,
    chunks: {
      ...state.chunks,
      progress: [],
      debug: [...state.chunks.debug, event.data],
    },
  };
}

export function handleProgressEvent(
  state: ContentProcessorState,
  event: StreamingEvent<'progress'>,
): ContentProcessorState {
  if (!event.data) return state;

  return {
    ...state,
    chunks: {
      ...state.chunks,
      progress: [...state.chunks.progress, event.data],
    },
  };
}
